import React, { useState} from 'react';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
export default function MyFiltrers({setReport, setPaginate, self}) {
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [formatDateStart, setFDS] = useState();
	const [formatDateEnd, setFDE] = useState();
	
	const getDateStart = 				params => {
		const fecha = window.$parseDate(params);
		setFDS( fecha );
		setStartDate(params);
	}
	const getDateEnd = params => {
		let end = window.$parseDate(params);
		const f1 = new Date(formatDateStart);
		const f2 = new Date(end);
		
		if( f2 < f1 ){
			toast.warning("No puedes seleccionar una fecha limite menor a la fecha de inicio");
			return false;
		}
		setFDE( end );
		setEndDate(params);
	}
	const getInfoGeneral = () => {
		let urlApi = window.$api+'/getInfoGeneral/'+formatDateStart;
		let display = { load : !self.state.display.load };
		self.setState({display});
		
		if( formatDateEnd ){
			urlApi = urlApi+'_'+formatDateEnd;
		}
		fetch(urlApi)
		.then(res=>res.json())
		.then(res=>{
			if(res.data.length > 0){
				setReport(res.data);
				setPaginate(res.paginate);
			}else{
				toast.warning('No se encontrarón ventas para este rango de fechas')
			}
			display = { load : !self.state.display.load };
			self.setState({display});
		});
	}
  	return (<>
      	<div className="xs-12 sm-3 md-3 lg-3">
			<label>Fecha de inicio:</label>
			<DatePicker
				dateFormat="dd-MM-yyyy"
				selected={startDate}
				onChange={(date)=>getDateStart(date,'start')} 
				locale="es"
				className="input-normal"
			/>
      	</div>
      	<div className="xs-12 sm-3 md-3 lg-3">
        	<label>Fecha final:</label>
			<DatePicker
				dateFormat="dd-MM-yyyy"
				selected={endDate}
				onChange={(date)=>getDateEnd(date,'end')} 
				locale="es"
				className="input-normal"
				dayClassName={date => date.getTime() === new Date('25-11-2021').getTime() ? 'disabled-date' : undefined}
			/>
      	</div>
		<div className='xs-12 sm-2 md-2 lg-2'>
			{
				formatDateStart?
				<div className='btn btn-green btn-small' onClick={()=>getInfoGeneral()} style={{padding:'8px 12px',top:'16px'}}>Buscar</div>:
				<div className='btn btn-lock btn-small' style={{padding:'8px 12px',top:'14px', position: 'relative'}}>Buscar</div>
			}
		</div>
    </>);
}
